var _ = require('underscore/underscore.js');
var Base = require('front/components/Base/Base');

var template = require('./JoinHowTo.jinja');
require('./JoinHowTo.less');

module.exports = Base.extend({

    template: template,


    initialize: function (options) {
        this.options = options || {};

        Base.prototype.initialize.call(this, options);
    }
});


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/JoinHowTo/JoinHowTo.js
// module id = 68
// module chunks = 0